import React from 'react';
import Modal from './Modal';

const ImagePreviewModal = ({ isOpen, onClose, imageUrl }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Previsualizar Imagen">
      <div className="modal-body image-preview-body"> {/* Clase para centrar contenido del cuerpo del modal */}
        {imageUrl ? (
          <img src={imageUrl} alt="Previsualización" className="image-preview" />
        ) : (
          <p>Cargando imagen...</p>
        )}
      </div>
    </Modal>
  );
};

export default ImagePreviewModal;